import 'angular';
import { CompanionClientEventHandler } from '@amzn/aws-workdocs-web-companion-common';

export interface CompanionClientEventHandlerService {
    getHandler: () => CompanionClientEventHandler;
}

angular.module('GorillaBoy')
.factory('CompanionClientEventHandlerService', [
    '$rootScope',
    '$uibModal',
    '$timeout',
    'ClientMetricsService',
    function CompanionClientEventHandlerService($rootScope: ng.IRootScopeService, $uibModal, $timeout, ClientMetricsService) {
        const METRICS_EVENTS = {
            WAITING_ON_COMPANION_DIALOG_OPENED: {name: 'WorkDocs_Companion_Waiting_Dialog_Opened'},
            WAITING_ON_COMPANION_DIALOG_DISMISSED: {name: 'WorkDocs_Companion_Waiting_Dialog_Dismissed'},
        };
        const handler: CompanionClientEventHandler = (event) => {
            if (event.event === 'RECONNECTING') {
                switch (event.callerFunctionName) {
                    default:
                        const reconnectPromise = event.data;
                        showCompanionDialogForReconnecting(reconnectPromise);
                        break;
                }
            }
        };

        function showCompanionDialogForReconnecting(promise: Promise<void>) {
            var openCancelled = false;
            var preparingModalInstance = $uibModal.open({
                templateUrl: './shared/waitingForFEClientModal.html'
            });
            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.WAITING_ON_COMPANION_DIALOG_OPENED, 1);
            preparingModalInstance.result.then(null, function() {
                openCancelled = true;
            });
            
            promise.then(function() {
                if (!openCancelled) {
                    $timeout(preparingModalInstance.dismiss, 0);
                } else {
                    ClientMetricsService.recordCounterEvent(METRICS_EVENTS.WAITING_ON_COMPANION_DIALOG_DISMISSED, 1);                        
                }
            }, function() {
                // The connection to Companion failed
                if (!openCancelled) {
                    $timeout(preparingModalInstance.dismiss, 0);
                    showCompanionDownloadModal();
                }
            });    
        }
        
        function showCompanionDownloadModal() {
            var modalInstance = $uibModal.open({
                templateUrl: './edit-modal/frictionless_edit_modal_dialog.html',
                controller: 'gbFrictionlessEditModalCtrl'
            });
            return modalInstance.result;
        };
        
        return {
            getHandler: () => handler
        } as CompanionClientEventHandlerService;
    }
]);